import { FormSectionGroup } from '@vwfs-bronson/bronson-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AddressFormNew } from '../../../../../../components/AddressFormNew';
import { BankDetailsNew } from '../../../../../../components/BankDetailsNew';
import { CompanyDetailsForm_ST_OL } from '../../../../../../components/CompanyDetailsFormNew/business/soleTrader/operatingLease/CompanyDetailsForm_ST_OL';
import { ContactPersonForm_ST_OL } from '../../../../../../components/ContactPersonForm/business/soleTrader/operatingLease/ContactPersonForm_ST_OL';
import { journeyDataSelectors } from '../../../../../../services/redux/features/journeyData.slice';
import { useFormSectionHelpers } from '../../../../../utils';

const getCustomerFormsToRender = (showBankDetails: boolean) => {
  return [
    'companyDetails',
    'companyAddress',
    ...(showBankDetails ? (['companyBankDetails'] as const) : []),
    'contactPerson',
  ] as const;
};

type FormId = ReturnType<typeof getCustomerFormsToRender>[number];

export const CustomerDataOperatingLeaseSoleTrader = () => {
  const [forms, setForms] = useState<ReadonlyArray<FormId>>(() => getCustomerFormsToRender(false));

  const isUpfrontPayment = useSelector(journeyDataSelectors.isUpfrontPayment);

  useEffect(() => {
    setForms([...getCustomerFormsToRender(!isUpfrontPayment)]);
  }, [isUpfrontPayment]);

  const getFormHelpers = useFormSectionHelpers(forms);

  return (
    <FormSectionGroup>
      <CompanyDetailsForm_ST_OL formHelpers={getFormHelpers('companyDetails')} />
      <AddressFormNew.OL
        formHelpers={getFormHelpers('companyAddress')}
        titleTranslationKey="addressForm:title:business"
        showCountry
      />
      <BankDetailsNew.OL
        formHelpers={getFormHelpers('companyBankDetails')}
        titleTranslationKey="bankDetailsForm:title:business"
      />
      <ContactPersonForm_ST_OL formHelpers={getFormHelpers('contactPerson')} />
    </FormSectionGroup>
  );
};
